export default function Game_Images() {
  return (
    <div>
      <h1>Game_Images Component</h1>
    </div>
  );
}
